import axios from 'axios';
import { message } from 'antd';

// 创建axios实例
const api = axios.create({
  baseURL: '/api', // 确保所有请求都使用/api前缀
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器 - 添加认证令牌
api.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token');

    // 如果存在token，则添加到请求头
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // 添加时间戳防止缓存
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      };
    }

    console.log('API请求:', config.url, config.params || config.data);

    return config;
  },
  error => {
    console.error('API请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误和认证问题
api.interceptors.response.use(
  response => {
    console.log('API响应:', response.config.url, response.status);
    return response;
  },
  error => {
    console.error('API响应错误:', error.config?.url, error.response?.status);

    // 处理401未授权错误
    if (error.response && error.response.status === 401) {
      console.log('用户未授权，需要重新登录');
      // 清除本地存储的token
      localStorage.removeItem('token');
      // 可以在这里添加重定向到登录页面的逻辑
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export const examApi = {
  getQuestions: async (params) => {
    try {
      console.log('Calling API with params:', params);
      const response = await api.get('/exam/economist_exam');
      console.log('API Response:', response);
      return response;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },
  submitExam: async (data) => {
    return await api.post('/exam/submit', data);
  },
};

export const documentApi = {
  upload: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return await api.post('/documents/upload', formData);
  },
};

// 导出API实例
export default api;